var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"opacity":"0.5","background-color":"black","flex-direction":"column","align-items":"center","color":"red","font-size":"40px","position":"absolute","width":"100%","height":"100%","display":"flex","justify-content":"center","z-index":"100"}},[_c('pre',[_vm._v("      "),_vm._t("default"),_vm._v("\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }